import { createActions } from 'redux-actions';
import { push } from 'react-router-redux';
import { request } from '../../services';
import { navigateBack } from 'actionCreators';
import { userGetSession } from '../../shared/actionCreators/user';
import { getEmployeeFilters, getEmployeePage } from '../../reducers';
import qs from 'qs';

/* NOTES
* To handle api 419 (Session expired) responses a
* JS Error will be throw from the request method.
* Each request call must have an error handler
* callback to manage any potential errors
* occured during an API request. If no particular
* error handling is needed a default callback should
* be used, otherwise the action dispatched in the
* callback must have an the error in the meta property
*/

/*
  Follow the convention of returning promises in thunks.
  That gives the ability of executing some code when the thunk
  finish... for example to show a succes message if the user
  is created
 */

const {
  employeeListRequest,
  employeeListSuccess,
  employeeListFailure,
} = createActions({
  EMPLOYEE_LIST_SUCCESS: [
    json => json,
    (json, filterParams) => ({ query: filterParams }),
  ],
}, 'EMPLOYEE_LIST_REQUEST', 'EMPLOYEE_LIST_FAILURE');

export function requestEmployeeList(arg_filters = null) {
  return (dispatch, getState) => {
    const state = getState();
    const page = getEmployeePage(state);
    const filters = arg_filters || getEmployeeFilters(state);
    const filterParams = qs.stringify(filters);
    dispatch(employeeListRequest());
    request(`employees?page=${page}&${filterParams}`)
      .then(({ json }) => dispatch(employeeListSuccess(json, filterParams)))
      .catch(error => dispatch(employeeListFailure(error)));
  };
}

const {
  employeeResourceRequest,
  employeeResourceSuccess,
  employeeResourceFailure,
} = createActions({
  EMPLOYEE_RESOURCE_REQUEST: id => ({ id }),
}, 'EMPLOYEE_RESOURCE_SUCCESS', 'EMPLOYEE_RESOURCE_FAILURE');

export function requestEmployee(id) {
  return (dispatch) => {
    dispatch(employeeResourceRequest(id));
    return request(`employees/${id}`)
      .then(({ json }) => dispatch(employeeResourceSuccess(json)))
      .catch(error => dispatch(employeeResourceFailure(error)));
  };
}

const {
  employeeResourceCreateRequest,
  employeeResourceCreateSuccess,
  employeeResourceCreateFailure,
} = createActions(
  'EMPLOYEE_RESOURCE_CREATE_REQUEST',
  'EMPLOYEE_RESOURCE_CREATE_SUCCESS',
  'EMPLOYEE_RESOURCE_CREATE_FAILURE',
);

export function createEmployee(employee, onSuccess) {
  return (dispatch) => {
    dispatch(employeeResourceCreateRequest());
    return request('employees/', {
      method: 'POST',
      body: { user: employee },
    })
      .then(({ json }) => {
        onSuccess(json.name, json.email);
        dispatch(employeeResourceCreateSuccess(json));
        dispatch(push('/employees'));
      },
        (error) => {
          dispatch(employeeResourceCreateFailure(error));
        });
  };
}

const {
  employeeResourceUpdateRequest,
  employeeResourceUpdateSuccess,
  employeeResourceUpdateFailure,
} = createActions(
  'EMPLOYEE_RESOURCE_UPDATE_REQUEST',
  'EMPLOYEE_RESOURCE_UPDATE_SUCCESS',
  'EMPLOYEE_RESOURCE_UPDATE_FAILURE',
);

export function updateEmployee(employee, onSuccess) {
  return (dispatch) => {
    dispatch(employeeResourceUpdateRequest());
    return request(`employees/${employee.id}`, { method: 'PUT', body: { user: employee } })
      .then(({ json }) => {
        onSuccess(); // this may change in the future when refactoring
        dispatch(employeeResourceUpdateSuccess(json));
        dispatch(userGetSession()); // Refresh user to match shared info with employee
        dispatch(navigateBack());
      })
      .catch(error => dispatch(employeeResourceUpdateFailure(error)));
  };
}

const {
  addEventToEmployeeRequest,
  addEventToEmployeeSuccess,
  addEventToEmployeeFailure,
} = createActions({
  ADD_EVENT_TO_EMPLOYEE_SUCCESS: (json, employeeId) => ({ event: json.event, employeeId }),
}, 'ADD_EVENT_TO_EMPLOYEE_FAILURE', 'ADD_EVENT_TO_EMPLOYEE_REQUEST');

export const addEventToEmployee = (employeeId, event) => (dispatch) => {
  dispatch(addEventToEmployeeRequest(event));
  return request(`employees/${employeeId}/events`, { method: 'POST', body: event })
    .then(({ json }) => dispatch(addEventToEmployeeSuccess(json, employeeId)))
    .catch(errors => dispatch(addEventToEmployeeFailure(errors)));
};

export function setEmployeeFilters(filter) {
  return (dispatch) => {
    dispatch({ type: 'EMPLOYEE_SET_FILTER', payload: filter });
    dispatch({ type: 'EMPLOYEE_RESET_PAGINATION' });
    dispatch(requestEmployeeList());
  };
}

export function resetEmployeeFilters() {
  return dispatch => (
    Promise.all([
      dispatch({ type: 'EMPLOYEE_RESET_FILTERS' }),
      dispatch({ type: 'EMPLOYEE_RESET_PAGINATION' }),
      dispatch(requestEmployeeList()),
    ])
  );
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/employees.js